module.exports = "/assets/f0ab4a0e782c449ff6d7923581df08a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BA.png
// module id = 1223
// module chunks = 0